export function isCadFormat(value) {
    return value === 'step' || value === 'iges' || value === 'brep';
}
export function cadFormatForExtension(extension) {
    switch (extension.toLowerCase()) {
        case 'step':
        case 'stp':
            return 'step';
        case 'iges':
        case 'igs':
            return 'iges';
        case 'brep':
            return 'brep';
        default:
            return null;
    }
}
